import { render, staticRenderFns } from "./ProviderUpdate.vue?vue&type=template&id=5e5923f6"
import script from "./ProviderUpdate.vue?vue&type=script&lang=js"
export * from "./ProviderUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports